import type { ReactNode } from "react";
import type { NoteKey } from "./types";
import { pilotProps } from "@/lib/pilot";

/**
 * The one line under the transcript, when something needs saying.
 *
 * `kind` picks the treatment: a pill for the time warning, red for anything
 * that went wrong, plain for the two that end a call normally. These were HTML
 * strings set with innerHTML while the page was one file; they are nodes now,
 * which is the whole reason the links in them are no longer written by hand.
 */
export const NOTES: Record<NoteKey, { kind: "" | "warn" | "err"; node: ReactNode }> = {
  warn: { kind: "warn", node: "30 seconds left" },
  end: {
    kind: "",
    node: (
      <>
        That's the end of the demo call. <a {...pilotProps}>Try for free</a> on your own
        phones.
      </>
    ),
  },
  limit: {
    kind: "",
    node: (
      <>
        You've used your demo calls for today. <a {...pilotProps}>Try for free</a> on
        your own phones.
      </>
    ),
  },
  blocked: {
    kind: "err",
    node: "Your microphone is blocked. Allow it in your browser's settings, then try again.",
  },
  nomic: { kind: "err", node: "No microphone found. Plug one in, or try on your phone." },
  // One line for both halves of the same answer: a call that never got up, and
  // one that dropped after ninety seconds. The visitor's next move is the same
  // either way, so a second note would be a screen nobody acts on differently.
  failed: { kind: "err", node: "Something went wrong with the call. Try again in a moment." },
};
